import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import VenuesPanels from '../../venues/Panels';

import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

@injectIntl
export default class Venues extends Component {
  render() {
    const {
      venues,
      intl: { messages: m },
    } = this.props;
    return (
      <div>
        <Toolbar>
          <Typography variant="h6">{m.app_venues}</Typography>
        </Toolbar>
        <div style={{ padding: 16 }}>
          <VenuesPanels venues={venues} />
        </div>
      </div>
    );
  }
}
